<template>
  <div :class="getClasses">
      <div class="flex">
        <div class="logo" />
        <div class="navs">
          <div class="nav" v-for="(item, index) in navs" :key="index">
            <span @click="navClick(item)">{{item.title}}</span>
            <div class="nav-items" v-if="item.items">
              <span @click="itemClick(item, i + 1)" v-for="(child, i) in item.items" :key="i">{{child}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="link-right" @click="login">
        <img :src="LOGIN" />
        ITSM系统登录
      </div>
    </div>
</template>

<script>
import LOGIN from '../assets/images/login.png'

export default {
  data () {
    return {
      LOGIN,
      navs: [{
        title: '首页',
        href: 'home'
      }, {
        title: '解决方案',
        href: 'solution',
        items: [
          '医共体数据中心解决方案',
          ...this.solution.map(item => item.name),
          'PACS影像混合云方案',
          '等保解决方案'
        ]
      }, {
        title: '自有产品',
        href: 'introduction',
        items: this.products.map(item => item.name)
      }, {
        title: '服务体系',
        href: 'help',
        items: this.helps.map(help => help.name)
      }, {
        title: '客户案例',
        href: 'examples'
      }, {
        title: '新闻资讯',
        href: 'news'
      }, {
        title: '关于我们',
        href: 'about'
      }],
      scrollTop: 0
    }
  },

  props: {
    page : {
      type: String,
      required: true
    },
    helps: {
      type: Array,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    solution: {
      type: Array,
      required: true
    }
  },

  created () {
    document.addEventListener('scroll', () => {
      this.scrollTop = document.documentElement.scrollTop
    })
  },

  destroyed () {
    document.removeEventListener('scroll')
  },

  methods: {
    navClick (item) {
      if (this.page !== item.href) {
        this.$emit('pageChange', item.href)
        this.$router.push(`/${item.href}`)
        document.body.scrollIntoView()
      } else {
        document.body.scrollIntoView()
      }
    },

    itemClick (item, i) {
      if (this.page !== item.href) {
        this.$emit('pageChange', item.href)
        this.$router.push(`/${item.href}${i}`)
      } else {
        window.location.hash = `#${item.href + i}`
      }
    },

    login () {
      window.open('http://itsm.aectech.com.cn')
    }
  },

  computed: {
    getClasses () {
      return `header ${this.scrollTop ? 'small' : ''}`
    }
  },

  watch: {
    '$route': function(route) {
        this.$emit('pageChange', route.name)
    },

    helps (newValue) {
      this.navs = [{
        title: '首页',
        href: 'home'
      }, {
        title: '解决方案',
        href: 'solution',
        items: [
          '医共体数据中心解决方案',
          ...this.solution.map(item => item.name),
          'PACS影像混合云方案',
          '等保解决方案'
        ]
      }, {
        title: '自有产品',
        href: 'introduction',
        items: this.products.map(item => item.name)
      }, {
        title: '服务体系',
        href: 'help',
        items: newValue.map(help => help.name)
      }, {
        title: '客户案例',
        href: 'examples'
      }, {
        title: '新闻资讯',
        href: 'news'
      }, {
        title: '关于我们',
        href: 'about'
      }]
    },

    products (newValue) {
      this.navs = [{
        title: '首页',
        href: 'home'
      }, {
        title: '解决方案',
        href: 'solution',
        items: [
          '医共体数据中心解决方案',
          ...this.solution.map(item => item.name),
          'PACS影像混合云方案',
          '等保解决方案'
        ]
      }, {
        title: '自有产品',
        href: 'introduction',
        items: newValue.map(item => item.name)
      }, {
        title: '服务体系',
        href: 'help',
        items: this.helps.map(help => help.name)
      }, {
        title: '客户案例',
        href: 'examples'
      }, {
        title: '新闻资讯',
        href: 'news'
      }, {
        title: '关于我们',
        href: 'about'
      }]
    },

    solution (newValue) {
      this.navs = [{
        title: '首页',
        href: 'home'
      }, {
        title: '解决方案',
        href: 'solution',
        items: [
          '医共体数据中心解决方案',
          ...newValue.map(item => item.name),
          'PACS影像混合云方案',
          '等保解决方案'
        ]
      }, {
        title: '自有产品',
        href: 'introduction',
        items: this.products.map(item => item.name)
      }, {
        title: '服务体系',
        href: 'help',
        items: this.helps.map(help => help.name)
      }, {
        title: '客户案例',
        href: 'examples'
      }, {
        title: '新闻资讯',
        href: 'news'
      }, {
        title: '关于我们',
        href: 'about'
      }]
    }
  }
}
</script>

<style lang="less" scoped>
  .header {
    position: fixed;
    z-index: 99;
    top: 0px;
    width: 100%;
    background: url('../assets/images/header_bg.png');
    height: 80px;
    max-width: 1920px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: height .2s ease-in-out;

    .flex {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: calc(100% - 120px);
    }

    .logo {
      background: url('../assets/images/header_logo.png');
      width: 192px;
      height: 36px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .navs {
      display: flex;
      position: relative;
      height: 100%;
      .nav {
        position: relative;
        padding: 0 12px;
        color: white;
        display: flex;
        align-items: center;
        height: 100%;
        cursor: pointer;
      }
      .nav-items {
        position: absolute;
        display: flex;
        flex-direction: column;
        top: 60px;
        left: 50%;
        width: 0px;
        background: rgba(0, 0, 0, .4);
        border-top: 1px dashed #f45937;
        opacity: 0;
        transition: all .5s ease-in-out;
        transform: translateX(-50%);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        > span {
          padding: 4px 8px;
          font-size: 9px;
          cursor: pointer;
        }

        > span:hover {
          color: #f45937;
        }
      }

      .nav:hover {
        .nav-items {
          opacity: 1;
          width: 180px;
          padding: 10px;
        }
      }

      .nav-items:hover {
        opacity: 1;
        width: 180px;
        padding: 10px;
      }
    }
  }

  .small {
    height: 50px;

    .nav-items {
      top: 50px!important;
    }
  }

  .link-right {
    position: absolute;
    color: white;
    cursor: pointer;
    right: 10px;
    font-size: 12px;
    top: 10px;
    text-decoration: underline;
    display: flex;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      padding-right: 4px;
    }
  }
</style>